const Lang         = require('lang');
const GlobalAlerts = require('./GlobalAlerts');

function sendContact() {
  const formSendContact = $('#send-contact');
  formSendContact.on('submit', send);
}

function send(event) {
  event.preventDefault();

  const url = $('.button-submit').data('route');
  const modal = $('#modal-contato');
  const inputs = {
    'nome': $('#nome').val(),
    'empresa': $('#empresa').val(),
    'telefone': $('#telefone').val(),
    'email': $('#email').val(),
    'mensagem': $('#mensagem').val(),
    'contactType': 'vexpenses',
    'urlConversao': window.location.href
  }

  for (const prop in inputs) {
    if (prop != 'mensagem' && !inputs[prop]) {
      return false;
    }
  }

  sendRequest(url, inputs)
    .always(function () {
      modal.modal('hide');
    })
    .done(function(data) {
      showMessage(data.message, 'success');
    })
    .fail(function(error) {
      showMessage(error.responseJSON.message, 'danger');
    });
}

function sendRequest(url, inputs) {
  return $.ajax({
    method: 'POST',
    url: url,
    data: inputs
  });
}

function showMessage(message, type) {
  GlobalAlerts.createAndShow({
    type: type,
    title: '',
    message: message
  });
}

exports.init = sendContact
